import type { IFaq } from "../config";

export const faqMock: IFaq = {
  title: "Frequently Asked Questions",
  items: [
    {
      question: "What is DeepSum?",
      answer:
        "DeepSum is an advanced AI tool that summarizes YouTube videos that uses AI technology to provide concise summaries of video content. Our tool helps users save time and extract key information quickly from YouTube videos.",
    },
    {
      question: "Why choose the DeepSum YouTube video summarizer?",
      answer: "DeepSum stands out as a leading YouTube Video Summarizer due to its accuracy, speed, and user-friendly interface.",
    },
    {
      question: "How to summarize YouTube videos with DeepSum?",
      answer:
        "To use our feature to get a summary of a YouTube video, simply install the DeepSum extension, navigate to any YouTube video, and click the summarize button. Our Summary Generator will instantly provide you with key points and insights.",
    },
    {
      question: "How does DeepSum summarize videos?",
      answer: "DeepSum uses AI algorithms to analyze video content, extract main ideas, and generate accurate summaries. Our YouTube Video Summarizer processes audio and textual elements to create comprehensive summaries.",
    },
    {
      question: "Can DeepSum summarize podcasts and news?",
      answer: "Our AI YouTube Summary technology can be applied to various video formats, including podcast videos and news hosted on YouTube.",
    },
    {
      question: "Can I summarize videos in other languages?",
      answer: "Yes, DeepSum can generate summaries for YouTube videos in 50+ languages, making it a versatile Summary Generator for global content.",
    },
    {
      question: "Can I summarize lengthy videos?",
      answer: "DeepSum is a video summarization tool with AI that can summarize YouTube videos of any length. Whether it's a short clip or a multi-hour lecture, our tool can provide concise summaries.",
    },
  ],
};
